// AdContentSharing optInBit is a tri-state value kept in sync with the server.
export const AD_CONTENT_SHARING_UNSET = 0;
export const AD_CONTENT_SHARING_DECLINED = 1;
export const AD_CONTENT_SHARING_OPTED_IN = 2;
